export const WizardStep = {
  READINESS: 'readiness',
  FEES: 'fees',
  BORROWERS_DELIVERY: 'borrowersDelivery',
  PREVIEW: 'preview',
  SEND: 'send',
};

export const WIZARD_STEPS = [
  { label: 'Readiness', value: WizardStep.READINESS, continueLabel: 'Continue' },
  { label: 'Fees', value: WizardStep.FEES, continueLabel: 'Save & Continue' },
  {
    label: 'Borrowers & Delivery',
    value: WizardStep.BORROWERS_DELIVERY,
    continueLabel: 'Continue',
  },
  { label: 'Preview', value: WizardStep.PREVIEW, continueLabel: 'Continue' },
  { label: 'Send', value: WizardStep.SEND, continueLabel: 'Send Disclosures' },
];

export const WIZARD_TITLE = 'Prepare Disclosures — Initial Loan Estimate';

export const INITIAL_BORROWERS_DELIVERY = {
  isSeeded: false,
  signerOrder: [],
  signers: {},
};

export const POST_SEND_COPY = {
  goToDisclosures: 'Go to Disclosures tab',
  backToLoan: 'Back to loan',
};

export const DIRTY_CLOSE_CONFIRMATION = {
  message: 'Discard disclosure preparation?',
  description:
    'You have unsaved changes in this wizard. Fee edits already saved to the loan are kept; unsaved wizard selections will be lost. Close anyway?',
  onAcceptButtonName: 'Discard',
};
